import React from "react";
import {useHistory} from "react-router-dom";
import success from "@assets/svg/success.svg";

const SuccessForm = () => {
  const history = useHistory()

  return (
    <div className={'mx-3'}>
      <div className="flex flex-col px-2 xl:px-22 lg:px-8 justify-center mx-auto mt-15" style={{maxWidth: '1800px', height: "100vh"}}>
        <div className={'bg-gray-200 rounded-2xl py-10 px-14'}>
          <img className="h-18 md:h-24 mx-auto my-10" src={success} alt="Logo"/>
          <div className={'text-xl md:text-4xl lg:text-6xl text-primary-500 font-bold text-center mb-1 md:mb-3'}>
            Porosia u krye me sukses.
          </div>
          <div className="px-2 lg:px-20">
            <p className="text-xs md:text-lg lg:text-2xl text-center text-brand-gray font-light">
              Faleminderit!
            </p>
          </div>
        </div>
        <div className="px-2 lg:px-20 mt-10 md:mt-5 lg:mt-10">
          <p className="text-xs md:text-base lg:text-xl text-center text-primary-500 cursor-pointer underline" onClick={() => history.push("/")}>
            Kthehu në homepage
          </p>
        </div>
      </div>
    </div>
  );
}

export default SuccessForm;

